import React from 'react'
import { UserSkillForm } from '../../../UserSkillForm'
import { StepForm } from '../StepForm'
import { CategorySkillOptions } from './types'
import { FormType } from '../types'
import { FocusSkillDescription } from '../FocusSkillDescription'

type Props = {
  formType: FormType
  skillOptions: CategorySkillOptions
}

export const StyledThirdForm: React.FC<Props> = (props) => {
  return (
    <StepForm formType={props.formType} title="経験スキル">
      <FocusSkillDescription />
      <UserSkillForm skillOptions={props.skillOptions} />
    </StepForm>
  )
}
